import { Injectable } from "@angular/core";
import * as wjcCore from "@grapecity/wijmo";
import {
  SafAccordion,
  SafAccordionItem,
  SafAlert,
  SafAnchor,
  SafButton,
  SafButtonEmbedded,
  SafCard,
  SafCheckbox,
  SafChip,
  SafDialog,
  SafDivider,
  SafIcon,
  SafList,
  SafListbox,
  SafListboxOption,
  SafListItem,
  SafLogo,
  SafMenu,
  SafMenuItem,
  SafPagination,
  SafProductHeader,
  SafProductHeaderItem,
  SafProgress,
  SafProgressRing,
  SafProgressText,
  SafSelect,
  SafSideNav,
  SafSplitter,
  SafSrOnly,
  SafStatus,
  SafSwitch,
  SafTab,
  SafTable,
  SafTabPanel,
  SafTabs,
  SafText,
  SafTextfield,
  SafToolbar,
  SafTooltip,
} from "@saffron/core-components";

@Injectable({
  providedIn: "root",
})
export class SaffronRegistryService {
  private components = [
    SafAccordion,
    SafAccordionItem,
    SafList,
    SafListItem,
    SafButton,
    SafAlert,
    SafAnchor,
    SafProductHeader,
    SafLogo,
    SafProductHeaderItem,
    SafIcon,
    SafSrOnly,
    SafSideNav,
    SafMenuItem,
    SafToolbar,
    SafButtonEmbedded,
    SafTextfield,
    SafCheckbox,
    SafDivider,
    SafPagination,
    SafTooltip,
    SafTab,
    SafTabs,
    SafTabPanel,
    SafTable,
    SafProgressRing,
    SafStatus,
    SafSelect,
    SafProgressText,
    SafProgress,
    SafDialog,
    SafListbox,
    SafListboxOption,
    SafText,
    SafMenu,
    SafChip,
    SafSplitter,
    SafCard,
    SafSwitch,
  ];

  registerComponents(licenseKey: string): void {
    this.components.forEach(component => component());

    wjcCore.setLicenseKey(licenseKey);
  }
}
